import React from "react";
import { formatDate } from "../../../core/data/marketOverviewText";
import { AUDITS } from "../../../core/theme/auditsTheme";

// "acme.co.uk was seen in 3 snapshots", each opening Advertiser Snapshot with
// acme.co.uk pinned. Only snapshots in this account's list are shown.
// website: from useWebsiteSearch ({ domain, searching, jobIds }).
export default function WebsiteMatches({ jobs, website, onOpenPinned }) {
  const { domain, searching, jobIds } = website;
  const ids = new Set(jobIds || []);
  const matches = jobs.filter(j => ids.has(j.id));

  return (
    <div className={AUDITS.website} aria-live="polite">
      {searching ? (
        <p className={AUDITS.websiteHead}>Searching for <span className={AUDITS.websiteDomain}>{domain}</span>…</p>
      ) : matches.length === 0 ? (
        <p className={AUDITS.websiteHead}><span className={AUDITS.websiteDomain}>{domain}</span> wasn't seen in any of your snapshots.</p>
      ) : (
        <>
          <p className={`${AUDITS.websiteHead} mb-1.5`}>
            <span className={AUDITS.websiteDomain}>{domain}</span> was seen in {matches.length} {matches.length === 1 ? "snapshot" : "snapshots"}. Click one to open its Advertiser Snapshot.
          </p>
          {matches.map(job => (
            <button key={job.id} type="button" onClick={() => onOpenPinned(job, domain)} className={AUDITS.websiteRow} title={`Open Advertiser Snapshot with ${domain} pinned`}>
              <span className={AUDITS.websiteName}>{job.name || (job.keywords || []).join(", ")}</span>
              <span className={AUDITS.websiteDate}>{formatDate(job.started_at)}</span>
            </button>
          ))}
        </>
      )}
    </div>
  );
}
